import http from 'hub-http/clients/apiClient';
import { registerMutation, useMutation } from 'data-fetching-client';
import getIn from 'immutable-less/transmute/getIn';
import { FLOW_BY_ID_FIELDNAME, getFlowByIdData, handleUpdateFlowMutation } from 'automation-ui-canvas/queries/flowQueries';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
import { useDispatch } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
const handleErrorResponseJSON = err => {
  throw getIn(['networkError', 'responseJSON'], err) || err;
};
export const UPDATE_FLOW_LISTS = registerMutation({
  fieldName: FLOW_BY_ID_FIELDNAME,
  args: ['flowId', 'opts', 'sourceApp', 'aiAssistants'],
  fetcher({
    flowId,
    opts,
    sourceApp,
    aiAssistants
  }) {
    return http.patch(`automationplatform/v1/hybrid/${flowId}?sourceapp=${sourceApp}&aiAssistants=${aiAssistants}`, opts);
  }
});
export const useUpdateFlowLists = () => {
  const dispatch = useDispatch();
  return useMutation(UPDATE_FLOW_LISTS, {
    update: handleUpdateFlowMutation(dispatch)
  });
};
/* could use this in wireUpdateFlowLists but don't want to risk change in
top-level components for current PR */
export const useGetUpdateFlowLists = () => {
  const [updateFlowListsMutation, updateFlowListsQuery] = useUpdateFlowLists();
  const updateFlowLists = variables => updateFlowListsMutation({
    variables
  }).then(getFlowByIdData).catch(handleErrorResponseJSON).catch(error => {
    const errorWithInfo = error;
    reportError({
      error: errorWithInfo,
      tags: {}
    });
    // Rethrow so consumers can catch
    throw errorWithInfo;
  });
  return [updateFlowLists, updateFlowListsQuery];
};
export const wireUpdateFlowLists = WrappedComponent => props => {
  const [updateFlowListsMutation] = useUpdateFlowLists();
  const updateFlowLists = variables => updateFlowListsMutation({
    variables
  }).then(getFlowByIdData).catch(handleErrorResponseJSON).catch(error => {
    const errorWithInfo = error;
    reportError({
      error: errorWithInfo,
      tags: {}
    });
    // Rethrow so consumers can catch
    throw errorWithInfo;
  });
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    updateFlowLists: updateFlowLists
  }));
};